import React, { useEffect, useState } from 'react';

import { Form } from 'react-bulma-components';

const { Select } = Form;

const majorTonics = ["C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B"];
const minorTonics = ["A","Bb","B","C","C#","D","Eb","E","F","F#","G","G#"];
var keyRegEx = /([A-G]{1}(?:[#b]?))?(m?)/;

const KeyTonicPicker = ({ name, value, onChange }) => {
  const [quality, setQuality] = useState("");
  const [tonic, setTonic] = useState("");
  function handleTonicOnChange(ev)
  {
    var e = new Object();
    e.target = {
      name: name,
      value: ev.target.value+quality
    }; 
    onChange(e);
  }
  
  function handleQualityOnChange(ev)
  {
    console.log("QualityChange: "+tonic+ev.target.value);
    let currentTonic = tonic;
    if( (ev.target.value === 'm' && !minorTonics.includes(tonic)) || 
        (ev.target.value !== 'm' && !majorTonics.includes(tonic))
    )
    {
      currentTonic = "";
    }
    var e = new Object();
    e.target = {
      name: name,
      value: currentTonic+ev.target.value
    }; 
    console.log(JSON.stringify(e));
    onChange(e);
  }

  useEffect(() => {
    if(!value){
      setTonic("");
      setQuality("");
      return;
    } 
    let keyMatch = value.match(keyRegEx);
    if(keyMatch!==undefined){
      setTonic(keyMatch[1]||"");
      setQuality(keyMatch[2]||"");
    }
    else{
      setTonic("");
      setQuality("");
    }
  }, [value]);
  return (
    <>
    <Select
      name={name}
      onChange={handleTonicOnChange}
      value={tonic||""}
    ><option key="0">Select a key tonic</option>
      {
        quality==="m"?
        minorTonics.map((tonic) =>
          <option key={tonic}>{tonic}</option>
        ):
        majorTonics.map((tonic) =>
          <option key={tonic}>{tonic}</option>
        )
      }
    </Select>
    <Select
        name={name}
        value={quality}
        onChange={handleQualityOnChange}
        mr={2}
      >
    <option key="0" value="">Major</option>
    <option key="1" value="m">Minor</option>
  </Select>
  </>
  )
};

export default KeyTonicPicker;
